
const getUserData = () => {
    try {
      const data = localStorage.getItem("userData");
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error("Error parsing userData from localStorage", error);
      return null;
    }
  };

  const getUserActiveDetails = () => {
    try {
      const data = localStorage.getItem("userActiveDetails");
      console.log("userActiveDetails from localStorage:", data);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error("Error parsing userActiveDetails from localStorage", error);
      return null;
    }
  };

 
  
   const status = getUserActiveDetails()?.userStatus;
  export const oldVersion = getUserActiveDetails()?.webVersion;
  export const isUserActive = status ? status === "active" : null;


  export const userRole = getUserData()?.user?.role;
  export const userId = getUserData()?.user?.uid;
  export const userUid = getUserData()?.user?.uid;
  export const userPhoneNumber = getUserData()?.user?.phoneNumber;
  export const userName = getUserData()?.user?.name;
  export const userEmail = getUserData()?.user?.emailId;
  export const teamIds = getUserData()?.teamId?.map((t) => t.id);
  export const teamList = getUserData()?.teamId;
  export const teamDetails = getUserData()?.teamId
  export const roleId = getUserData()?.user?.roleObj?.value;

  export const department = getUserData()?.user?.department;


  export const isSale = department?.name === "Sales";
  export const isManagement = department?.name === "Management";
  export const isRevenue = department?.name === "Revenue";


  

  


  export const accessModule = (() => {
    const accessModules = getUserData()?.user?.accessModules || {};
  
    return {
      glFunnelModule: accessModules.glFunnelCrm || false,
      hrModule: accessModules.hr || false,
      taskManagerModule: accessModules.taskManager || false,
      propertyProcurementModule: accessModules.propertyProcurement || false,
      geoGoModule: accessModules.geoGo || false,
      accountsProModule: accessModules.accountsPro || false,
    };
  })();
  
   